<template>
  <!--
    Meldungstext, in dem „Support" anklickbar ist (Kundenfeedback 16.10.2026,
    II). Angemeldet öffnet der Link „Fehler melden" vorbelegt mit der Meldung
    (inkl. Bildschirmfoto), sonst eine E-Mail an den Support.
  -->
  <span v-if="mention" class="support-text">{{ mention.before }}<a
    v-if="!isAuthenticated"
    class="support-text__link"
    data-testid="support-link"
    :href="mailto"
  >{{ mention.word }}</a><button
    v-else
    class="support-text__link"
    data-testid="support-link"
    :title="$gt('Fehler an den Support melden')"
    type="button"
    @click="openReport"
  >{{ mention.word }}</button>{{ mention.after }}</span>
  <span v-else>{{ text }}</span>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useAuthStore } from '@/stores/authStore'
  import { useUiStore } from '@/stores/uiStore'
  import { splitSupportMention, supportMailto, supportReportPrefill } from '@/utils/supportMention'

  const props = defineProps<{ text?: string | null }>()
  const emit = defineEmits<{ (e: 'support'): void }>()

  const mention = computed(() => splitSupportMention(props.text))
  const isAuthenticated = computed(() => useAuthStore().isAuthenticated)
  const mailto = computed(() => supportMailto(props.text || ''))

  function openReport () {
    useUiStore().openBugReport(supportReportPrefill(props.text || '', document.querySelector('h1')?.textContent ?? ''))
    emit('support')
  }
</script>

<style scoped>
.support-text__link {
  display: inline;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
.support-text__link:hover { text-decoration-thickness: 2px; }
.support-text__link:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; border-radius: 2px; }
</style>
